import { call, put, takeLatest } from "redux-saga/effects";
import { getWorkflowApi } from "../../../api/apiLists/workflow";
import {
  fetchWorkflowDetailFailure,
  fetchWorkflowDetailRequest,
  fetchWorkflowDetailStart,
  fetchWorkflowDetailSuccess
} from "../../slices/workflow";
import { callWorkflowApi, requireWhatsAppModuleAccess } from "./workflowSagaHelper";

function* handleFetchWorkflowDetail(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  try {
    yield put(fetchWorkflowDetailStart());

    const req = action.payload || { operation: "GET_WORKFLOW", payload: {} };
    const res = yield callWorkflowApi(getWorkflowApi, req);

    if (res?.status) {
      yield put(fetchWorkflowDetailSuccess(res?.data?.workflow || null));
      return;
    }

    yield put(fetchWorkflowDetailFailure(res?.errMsg || "Failed to load workflow"));
  } catch (error) {
    yield put(fetchWorkflowDetailFailure(error.message || "Failed to load workflow"));
  }
}

export default function* workflowDetailSaga() {
  yield takeLatest(fetchWorkflowDetailRequest.type, handleFetchWorkflowDetail);
}
